import { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import { ConnectionContext } from "../context/Connection/ConnectionContext";

// Liga os eventos do socket ao ConnectionContext. O estado da conexão é
// mostrado só pelo indicador discreto na Sidebar — sem toast.
const useSocketConnection = () => {
  const { socket } = useContext(AuthContext);
  const { onDisconnected, onReconnecting, onConnected, onReconnectError } =
    useContext(ConnectionContext);

  useEffect(() => {
    if (!socket || typeof socket.onConnectionEvent !== "function") return;

    const handleConnected = () => {
      onConnected();
    };

    const handleDisconnected = (reason) => {
      // Desconexão feita pelo próprio app (logout, forceReconnect): não é queda
      if (reason === "io client disconnect") return;
      onDisconnected(reason);
    };

    const handleReconnecting = (attemptNumber) => {
      onReconnecting(attemptNumber);
    };

    const handleReconnectError = (error) => {
      onReconnectError(error);
    };

    socket.onConnectionEvent("connected", handleConnected);
    socket.onConnectionEvent("disconnected", handleDisconnected);
    socket.onConnectionEvent("reconnecting", handleReconnecting);
    socket.onConnectionEvent("reconnect_error", handleReconnectError);

    return () => {
      socket.offConnectionEvent("connected", handleConnected);
      socket.offConnectionEvent("disconnected", handleDisconnected);
      socket.offConnectionEvent("reconnecting", handleReconnecting);
      socket.offConnectionEvent("reconnect_error", handleReconnectError);
    };
  }, [socket, onDisconnected, onReconnecting, onConnected, onReconnectError]);
};

export default useSocketConnection;
